/**
 * Report rows, latest first (owner, 2026-10-24: Sale Summary read oldest first).
 *
 * A row with a bill number runs by bill number, latest first (owner, 2026-10-24:
 * "sorted by date and time, then why are bill numbers random?"). `bill_time` is
 * when the table opened, while the number is given when the bill prints, so by
 * opening time the numbers jump. A row with no bill yet goes last. The business
 * day leads when the row has one: numbers restarted at 1 on the go-live day, so
 * today's Bill 1 is newer than yesterday's Bill 66.
 *
 * Otherwise the time a row is sorted by is its first timestamp column
 * (`cancelled_at`, …), else its business day (`order_date`, `date`). Rows of the
 * same day fall back to the order number, latest first; with neither they keep
 * the server's order, which is a ranking (items by qty) worth keeping.
 * A report with no time column (top items, khata balances) is left as sent.
 */
const TIMESTAMP = /(_at|_time)$/;
const DAY = /^(order_)?date$|^day$/;
const BILL = /^bill_number$/;
const ORDER = /^order_number$/;

const when = value => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? String(value) : parsed;
};

const compareDesc = (a, b) => {
  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return a < b ? 1 : -1;
};

export function latestFirst(rows) {
  if (!Array.isArray(rows) || rows.length < 2) return rows;
  const keys = Object.keys(rows[0]);
  const billKey = keys.find(key => BILL.test(key));
  const dayKey = keys.find(key => DAY.test(key));
  const timeKey = keys.find(key => TIMESTAMP.test(key)) || dayKey;
  if (!billKey && !timeKey) return rows;
  const orderKey = keys.find(key => ORDER.test(key));
  const number = (row, key) => (key ? Number(row[key]) || null : null);
  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) =>
      (billKey && dayKey ? compareDesc(when(a.row[dayKey]), when(b.row[dayKey])) : 0)
      || (billKey ? compareDesc(number(a.row, billKey), number(b.row, billKey)) : 0)
      || (timeKey ? compareDesc(when(a.row[timeKey]), when(b.row[timeKey])) : 0)
      || compareDesc(number(a.row, orderKey), number(b.row, orderKey))
      || a.index - b.index)
    .map(({ row }) => row);
}
